import { Component, OnInit, Input } from "@angular/core";
import { EventEmittersService } from "src/app/services/event-emitters.service";
import { ILayer } from "src/app/interface/layer";
import Swal from "sweetalert2";
import { GenericLayerService } from "src/app/services/generic-layer.service";
import { AuthenticationService } from "src/app/services/authentication.service";
import { environment } from "src/environments/environment";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { CustomTranslatePipe } from "../../shared/custom-translate.pipe";
import { MatOptionModule } from "@angular/material/core";
import { NgFor, NgIf } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { IUser } from "src/app/interface/user";

@Component({
    selector: "app-sms-map-export",
    templateUrl: "./map-export.component.html",
    styleUrls: ["./map-export.component.scss"],
    standalone: true,
    imports: [MatFormFieldModule, MatSelectModule, FormsModule, NgFor, MatOptionModule, NgIf, TranslateModule, CustomTranslatePipe]
})
export class MapExportComponent implements OnInit {
  constructor(
    private genericLayerService: GenericLayerService, 
    private authenticationService: AuthenticationService, 
    private translateService: TranslateService,
    private eeService: EventEmittersService
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  @Input() map;
  @Input() Geoprocessor;
  selectedRegion;
  selectedLayer;
  layerList: ILayer[] = [];
  regionList;
  gpServiceUrl;
  currentUser: IUser;
  RegionLabel;
  AssetClassLabel;
  ExportLabel;
  ExportHeading;
  ExportStatus;
  loading = false; // Loading Control //

  ngOnInit() {
    this.ExportHeading = "Userscreens.mapexport.exportheading";
    this.RegionLabel = "Userscreens.mapexport.regionlabel";
    this.AssetClassLabel = "Userscreens.mapexport.assetclasslabel";
    this.ExportLabel = "Userscreens.mapexport.exportlabel";
    this.regionList = [];
    this.layerList = [];
    this.layerList = this.eeService.userLayers.filter((obj: ILayer) => obj.type === "inventory");
    this.regionList = this.map.smsRegiondata;
    this.layerList.push({
      accessPrivilege: "Data Editor",
      layerId: 22,
      name: "Sign",
      type: "inventory",
      lyrObj: null,
      visible: true,
      alias: "Sign",
      aliasSL: "Sign"
    });
    this.layerList.push({
      accessPrivilege: "Data Editor",
      layerId: 23,
      name: "Light",
      type: "inventory",
      lyrObj: null,
      visible: true,
      alias: "Light",
      aliasSL: "Light"
    });
    this.gpServiceUrl = new this.Geoprocessor(environment.gpService);
  }

  export() {
    try {
      if (this.selectedRegion === undefined || this.selectedRegion === "") {
        Swal.fire(this.translateService.instant("Userscreens.alertmapexport.selectregion"));
      } else if (this.selectedLayer === undefined || this.selectedLayer === "") {
        Swal.fire(this.translateService.instant("Userscreens.alertmapexport.selectasset"));
      } else {
        const params = {
          // eslint need to fix
          // eslint-disable-next-line camelcase
          in_clientID: this.currentUser.clientId,
          // eslint-disable-next-line camelcase
          in_region: "Region" + this.selectedRegion.regionLevel + "='" + this.selectedRegion.regionName + "'",
          // eslint-disable-next-line camelcase
          in_layerName: this.selectedLayer.name
        };
        this.gpServiceUrl.submitJob(params, this.gpJobComplete.bind(this), this.gpJobStatus.bind(this), this.gpJobFailed.bind(this));
      }
    } catch (error) {
      console.error(error);
    }
  }

  onChange() {
    this.ExportStatus = "";
    this.loading = false;
  }

  gpJobComplete(jobinfo) {
    try {
      const URLData = environment.gpService + "/jobs/" + jobinfo.jobId + "/results/outputPath";
      this.genericLayerService.getServiceInfo(URLData).subscribe(
        (urlData: any) => {
          const OpenURL = urlData.value;
          window.open(OpenURL);
        },
        (err) => {
          console.log(err);
        }
      );
    } catch (error) {
      console.error(error);
    }
  }

  gpJobStatus(jobinfo) {
    try {
      switch (jobinfo.jobStatus) {
        case "esriJobSubmitted":
          this.ExportStatus = this.translateService.instant("Userscreens.alertmapexport.statussubmitted");
          this.loading = true;
          break;
        case "esriJobExecuting":
          this.ExportStatus = this.translateService.instant("Userscreens.alertmapexport.statusprocessing");
          this.loading = true;
          break;
        case "esriJobSucceeded":
          this.ExportStatus = this.translateService.instant("Userscreens.alertmapexport.chkdownloadfldr");
          this.loading = false;
          break;
      }
    } catch (error) {
      console.error(error);
    }
  }
  gpJobFailed(error) {
    Swal.fire(error);
  }
}
